module.exports = __webpack_public_path__ + "img/chips.82df72cb.jpeg";